import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'productUnit',
    serviceName: 'graphql',
    query: gql`
      query productUnit {
        productUnit {
          data {
            id
            title
          }
        }
      }
    `,
  },
  update: {
    name: 'updateProductUnit',
    serviceName: 'admin',
    query: gql`
      mutation updateProductUnit($ids: [String]!, $title: String!) {
        updateProductUnit(ids: $ids, title: $title) {
          messages
        }
      }
    `,
  },
};

export default schema;
